/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo, useState, useEffect, useRef, useLayoutEffect, useCallback } from 'react';
import { CaretDownOutlined, CaretRightOutlined, InfoCircleOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import Style from './style';
import { Typography, Input, Form } from 'antd';
import { GetIcon } from 'datastake-daf/dist/components';

const { Paragraph } = Typography;

const CustomWrapper = ({
  body = "",
  type = "",
  className,
  onChange = () => { },
  defaultValue = null,
  formDescription,
  t = (s) => s,
  icon = null,
  descIcon,
}) => {
  const [initialHideDone, setInitialHideDone] = useState(false);
  const [bodyShown, setBodyShown] = useState(true);
  const bodyRef = useRef();
  const [maxHeight, setMaxHeight] = useState(bodyRef.current ? bodyRef.current.scrollHeight + 10 : 0);

  useLayoutEffect(() => {
    if (bodyShown) {
      setMaxHeight(bodyRef.current ? bodyRef.current.scrollHeight + 10 : 0);
    } else {
      setMaxHeight(0);
    }
  }, [bodyShown]);

  const config = useMemo(() => {
    switch (type) {
      case 'about':
        return {
          icon: <InfoCircleOutlined />,
          className: 'about',
          title: 'About this section',
        };
      case 'comment':
      case 'commentOutput':
        return {
          className: 'comment',
          title: 'Comments on this section',
        };
      case 'whatsThis':
        return {
          icon: <QuestionCircleOutlined />,
          className: 'about',
          title: 'What’s this section',
        }
      default:
        return {
          icon: <InfoCircleOutlined />,
          className: 'about',
          title: 'About this section',
        };
    }
  }, [type]);

  const resizeWrapper = useCallback(() => {
    setTimeout(() => {
      setMaxHeight(bodyRef.current ? bodyRef.current.scrollHeight + 10 : 150);
    }, 100);
  }, []);

  useEffect(() => {
    if (bodyShown) {
      window.addEventListener('resize', resizeWrapper);
      return () => window.removeEventListener('resize', resizeWrapper);
    }
  }, [bodyShown]);

  useLayoutEffect(() => {
    if (!bodyShown) {
      setBodyShown(true);
    }
    resizeWrapper();
  }, [body, type]);

  useLayoutEffect(() => {
    if (bodyRef.current) {
      setMaxHeight(bodyRef.current.scrollHeight + 10);
    }
  }, [bodyRef.current]);

  if (!['header', 'comment', 'commentOutput'].includes(type)) {
    return null;
  }

  return (
    <Style className={`wrapper ${config.className} ${className}`}>
      {type === 'header' ? (
        <div className="header">
          <div>
            <h1 className="m-0 header-title">{body}</h1>
            <div className="flex-row">
              {descIcon ? (
                <div className="flex flex-column justify-content-center mr-2">
                  {descIcon}
                </div>
              ) : null}

              {formDescription ? <p>{formDescription}</p> : null}
            </div>
          </div>
          {icon && (
            <div className="icon-c">
              <GetIcon icon={icon} />
            </div>
          )}
        </div>
      ) : type === 'comment' ? (
        <Form layout="vertical">
          <Form.Item label={t('Comments on this section')}>
            <Input.TextArea value={defaultValue} autoSize={{ maxRows: 5, minRows: 5 }} onChange={onChange} placeholder={t('Type')} />
          </Form.Item>
        </Form>
      ) : type === 'commentOutput' ? (
        <div className="body">
          <label>{t('Comments on this section')}</label>
          {body ? (
            <Paragraph ellipsis={{ rows: 6 }}>
              <p>{body}</p>
            </Paragraph>
          ) : <p><span className='text-muted'>{t('Unanswered')}</span></p>}
        </div>
      ) : (
        <>
          <div className="header">
            <div>
              <span>{t(config.title)}</span>
            </div>
            <div>
              {config.icon}
            </div>
            <div className="main">
              <div onClick={() => {
                setBodyShown((prev) => !prev);
                if (!initialHideDone) {
                  setInitialHideDone(true);
                }
              }}>
                <span>{bodyShown ? t('Hide') : t('Show')}</span>
                {bodyShown
                  ? <CaretDownOutlined />
                  : <CaretRightOutlined />
                }
              </div>
            </div>
          </div>
          <div className="body" ref={bodyRef} style={{ maxHeight }}>
            {type === 'comment' ? <Input.TextArea value={defaultValue} autoSize={{ maxRows: 5, minRows: 5 }} onChange={onChange} placeholder={t('Add your comments here')} /> : null}
            {type !== 'comment' ? <Paragraph ellipsis={{ rows: 6 }}>
              <p>{body}</p>
            </Paragraph> : null}
          </div>
        </>
      )}
    </Style>
  );
};

export default CustomWrapper;
